import { Link } from "react-router-dom";
import VerificationBadge from "./VerificationBadge";
import LastVerifiedDate from "./LastVerifiedDate";
import OfficialLinkButton from "./OfficialLinkButton";

export default function SoftwareCard({ software }) {
  return (
    <article className="soft-card soft-card-hover flex h-full flex-col p-5 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <div><p className="text-xs font-black uppercase tracking-[0.16em] text-blue-700">{software.category}</p><h2 className="mt-2 text-2xl font-black text-neutral-950">{software.name}</h2></div>
        <VerificationBadge />
      </div>
      <p className="mt-2 text-sm font-bold text-neutral-500">Developed by {software.developer}</p>
      <p className="mt-4 text-sm leading-7 text-neutral-600">{software.description}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <span className="data-badge">{software.license}</span>
        {software.rosSupport.map((item) => <span key={item} className="data-badge">{item}</span>)}
      </div>
      <div className="mt-auto pt-6">
        <LastVerifiedDate date={software.lastVerified} />
        <div className="mt-4 flex flex-wrap gap-2">
          <Link className="btn-primary" to={`/robotics-software/${software.slug}`}>View software details</Link>
          <OfficialLinkButton href={software.website} ariaLabel={`Visit the official ${software.name} website`}>Official website</OfficialLinkButton>
        </div>
      </div>
    </article>
  );
}
